<template>
  <div class="position-relative welcome p-30 overflow-auto">
    <div class="wp-100" style="max-width: 1226px; margin: 0 auto; display: flex; flex-direction: column;">
      <p class="text-center mb-30">
        Для работы с платформой выберете любой раздел в меню<br />
        Рекомендуемый браузер Google Chrome
      </p>
      <div class=" gap-30" style="display: grid; grid-template-columns: repeat(3, 1fr);">
        <div class="p-30 bg-white d-flex flex-column rounded-15 welcome-card tw-shadow-[0_6px_12px_0_rgba(0,0,0,0.1),0_-1px_1px_0_rgba(0,0,0,0.05)]" v-for="item of videoList"
          :key="item.academy__id">
          <div class="mb-15 flex-grow-1">
            <div class="mb-15 fw-semi-bold">
              {{ item.academy__welcome_title }}
            </div>
            <div class="fsc-14" style="min-height: 85px">
              {{ item.academy__welcome_description }}
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <div class="btn btn-sm btn-danger action-hover text-white fsc-12 fw-medium" @click="
              $modal.show('modalVideoSupport', {
                videoID: item.academy__video_link,
              })
              ">
              Смотреть видео
            </div>
          </div>
        </div>
      </div>
      <div class="mt-30 pb-50 d-flex justify-content-center">
        <RouterLink to="/academy" class="btn btn-primary action-hover px-60 py-10 fsc-12 fw-medium">
          Смотреть все инструкции
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralService from "@/api/GeneralService";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      videoList: null,
    };
  },
  mounted() {
    GeneralService.get(`/welcome/records`)
      .then((data) => {
        this.videoList = data.data.data.rows.sort(
          (a, b) => a.academy__welcome_position - b.academy__welcome_position
        );
      })
      .catch((e) => {
        this.$toast.error(e.response.data.message ?? e, { duration: 5000 });
      });
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>

<style lang="scss">
.welcome-card {
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 3px 10px 23px 0px #0000001a;

    box-shadow: 14px 39px 41px 0px #00000017;

    box-shadow: 31px 88px 56px 0px #0000000d;

    box-shadow: 55px 156px 66px 0px #00000003;

    box-shadow: 87px 243px 72px 0px #00000000;

    box-shadow: 0px 15px 25px 0px #00000040;
  }
}

.welcome {
  background-color: #F4F1EC;
  display: flex;
  position: relative;
  padding: 0 31px;
  min-height: 100vh;
  color:#000;

  &__bg-img {
    width: 100%;
    margin: auto;
  }

  &__desc {
    position: absolute;
    top: calc(50% - 88px);
    font-size: 30px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    text-align: center;
  }
}
</style>
